import AccountLogic from "@/components/AccountLogic";
import DiscoverButton from "@/components/DiscoverButton";
import DiscoverIconSM from "@/components/DiscoverIconSm";
import PlayerBar from "@/player/PlayerBar";
import { useUser } from "@auth0/nextjs-auth0/client";
import {
  Button,
  Center,
  Container,
  Divider,
  Heading,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import Head from "next/head";
import Link from "next/link";

export default function Account() {
  const { user, error } = useUser();
  const { colorMode } = useColorMode();

  const buttonText = colorMode === "light" ? "text-black" : "text-white";
  const buttonBG = colorMode === "light" ? "bg-white" : "bg-black";

  return (
    <>
      <Head>
        <title>Account</title>
        <link rel="icon" href="/songcards.png" />
        <meta
          name="description"
          content="Dive into your Songcard collection and unlock rewards"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          itemProp="image"
          content="https://songcards.io/songcards_unlock_your_sound.jpg"
        />
        <link rel="canonical" href={`https://songcards.io/account`} />
        <link rel="apple-touch-icon" href="/icon.png" />
        <meta
          property="og:image"
          content="https://songcards.io/songcards_unlock_your_sound.jpg"
        />
        <meta property="og:url" content="https://songcards.io/account" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Account" />
        <meta
          property="og:description"
          content="Dive into your Songcard collection and unlock rewards"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Account" />
        <meta
          name="twitter:description"
          content="Dive into your Songcard collection and unlock rewards"
        />
        <meta
          name="twitter:image"
          content="https://songcards.io/songcards_unlock_your_sound.jpg"
        />
      </Head>
      {user && <AccountLogic user={user} />}

      {error && <>There was an error</>}
      {/* <Center>
        <MyAppleSigninButton />
      </Center> */}
      {!user && (
        <>
          <Center>
            <Button
              as="a"
              href="/api/auth/login"
              size="sm"
              border="1px"
              borderColor="gray"
            >
              Login / Sign up
            </Button>
          </Center>

          <Center mt={5}>
            <Text>to view your collection</Text>
          </Center>
          <Center>
            <Divider maxW={300} mt={10} />
          </Center>
          <br />
          <Center mt={5}>
            <Heading
              as="h2"
              size="lg"
              textAlign="center"
              mb={5}
              mt={0}
              maxW="xs"
            >
              Don{`'`}t have any Songcards yet?
            </Heading>
          </Center>
          <DiscoverButton />
          <Center>
            <Divider maxW={300} mt={5} mb={5} />
          </Center>
        </>
      )}

      <Center>
        <Divider maxW={300} mt={5} mb={5} />
      </Center>
      <Center mt={10} mb={0}>
        <Heading as="h2" size="lg" textAlign="center" mb={5} mt={0} maxW="sm">
          Support and general enquiries
        </Heading>
      </Center>
      <Center mb={10}>
        <a
          target="#"
          href="https://docs.google.com/forms/d/e/1FAIpQLSfelEQmiE8Yr589pqjhEDeGJXyqGwuYZ-ROTlTy_b6mw5ErqA/viewform?usp=sf_link"
        >
          <button className="mt-7 mb-5 rounded-2xl p-px bg-[linear-gradient(to_right,rgba(255,153,213,0.9),rgba(255,102,196,0.9),rgba(255,102,196,0.9),rgba(255,102,196,0.9),rgba(255,153,213,0.9))] bg-[length:400%_auto] animate-gradient">
            {" "}
            <div
              className={`rounded-2xl p-3 w-100 ${buttonBG} font-semibold ${buttonText}`}
            >
              Get In Touch
            </div>
          </button>
        </a>
      </Center>
      <Center>
        <Divider maxW={300} mt={5} mb={5} />
      </Center>
      <Center mt={5}>
        <Link href={`/terms`}>
          <div>Terms of service</div>
        </Link>
      </Center>
      <DiscoverIconSM />
      <Container mb={200}></Container>
      <PlayerBar />
    </>
  );
}
